import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bradwestfall/Desktop/ReactTraining/Projects/monorepo/reacttraining.com/src/page-templates/DefaultMarkdownPage.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "workshop-code-of-conduct"
    }}><a parentName="h1" {...{
        "href": "#workshop-code-of-conduct",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Workshop Code of Conduct`}</h1>
    <p>{`All attendees, instructors, and hosts at our workshop are required to agree with the following code of conduct. Organizers will enforce this code throughout the event. We are expecting cooperation from all participants to help ensuring a safe environment for everybody.`}</p>
    <h2 {...{
      "id": "need-help"
    }}><a parentName="h2" {...{
        "href": "#need-help",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Need Help?`}</h2>
    <p>{`Email us at `}<a parentName="p" {...{
        "href": "mailto:hello@reacttraining.com"
      }}>{`hello@reacttraining.com`}</a>{`.`}</p>
    <h2 {...{
      "id": "the-quick-version"
    }}><a parentName="h2" {...{
        "href": "#the-quick-version",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`The Quick Version`}</h2>
    <p>{`Our workshop is dedicated to providing a harassment-free experience for everyone, regardless of gender, gender identity and expression, age, sexual orientation, disability, physical appearance, body size, race, or religion (or lack thereof). We do not tolerate harassment of workshop participants in any form. Sexual language and imagery is not appropriate anywhere for the workshop, including presentations, questions, comments, Twitter and other online media. Workshop participants violating these rules may be sanctioned or expelled from the workshop without a refund at the discretion of the workshop organizers.`}</p>
    <h2 {...{
      "id": "the-less-quick-version"
    }}><a parentName="h2" {...{
        "href": "#the-less-quick-version",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`The Less Quick Version`}</h2>
    <p>{`Harassment includes offensive verbal comments related to gender, gender identity and expression, age, sexual orientation, disability, physical appearance, body size, race, religion, sexual images in public spaces, deliberate intimidation, stalking, following, harassing photography or recording, sustained disruption of lectures or other events, inappropriate physical contact, and unwelcome sexual attention.`}</p>
    <p>{`Participants asked to stop any harassing behavior are expected to comply immediately.`}</p>
    <p>{`If a participant engages in harassing behavior, the workshop organizers may take any action they deem appropriate, including warning the offender or expulsion from the workshop with no refund.`}</p>
    <p>{`If you are being harassed, notice that someone else is being harassed, or have any other concerns, please contact the workshop or host staff immediately.`}</p>
    <p>{`Workshop staff will be happy to help participants contact venue security or local law enforcement, provide escorts, or otherwise assist those experiencing harassment to feel safe for the duration of the workshop. We value your attendance.`}</p>
    <p>{`This Code of Conduct is borrowed from Conference Code of Conduct.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      